// ---------------------------------------------------------------------------
// FOOD MENU (served by Tacoverse inside Barverse) — EDITABLE DATA.
// Typography-driven presentation only: NO food photography, NO invented prices.
// ---------------------------------------------------------------------------
export const FOOD_CATEGORIES = [
  {
    id: "tacos",
    label: "Tacos",
    items: [
      { name: "The Royal", style: "Carne Asada" },
      { name: "The Grilled", style: "Grilled Chicken" },
      { name: "The Feast", style: "Ground Beef" },
      { name: "The Cruncher", style: "Crispy Chicken" },
      { name: "The Beast", style: "Pork Carnitas" },
      { name: "The Epic", style: "Beef Carnitas" },
      { name: "The Coastal", style: "Battered Fish" },
      { name: "The Gulfstream", style: "Fried Shrimp" },
      { name: "The Gulfstream", style: "Grilled Shrimp" },
      { name: "The Glow", style: "Cauliflower" },
    ],
  },
  {
    id: "burritos",
    label: "Burritos",
    items: [
      { name: "Royal Grande", style: "Carne Asada" },
      { name: "Gulfstream Grande", style: "Shrimp" },
      { name: "Feast Grande", style: "Ground Beef" },
      { name: "Grilled Grande", style: "Grilled Chicken" },
      { name: "Glow Grande", style: "Cauliflower" },
    ],
  },
  {
    id: "bowls",
    label: "Bowls",
    items: [
      { name: "Royal", style: "Carne Asada" },
      { name: "Grill", style: "Grilled Chicken" },
      { name: "Surge", style: "Shrimp" },
      { name: "Glow", style: "Cauliflower" },
    ],
  },
  {
    id: "salads",
    label: "Salads",
    items: [
      { name: "Royal" },
      { name: "Grill" },
      { name: "Surge" },
      { name: "Glow" },
    ],
  },
  {
    id: "quesadillas",
    label: "Quesadillas",
    items: [
      { name: "Plain", style: "Cheese" },
      { name: "Royal", style: "Carne Asada" },
      { name: "Grilled", style: "Grilled Chicken" },
      { name: "Gulfstream", style: "Shrimp" },
    ],
  },
  {
    id: "sides",
    label: "Sides",
    items: [
      { name: "The Divine Queso" },
      { name: "Ultimate Chips" },
      { name: "Power Fries" },
      { name: "Chips & Salsa" },
      { name: "Chips & Guacamole" },
      { name: "Chips & Queso" },
      { name: "Fries" },
      { name: "Cilantro Rice" },
      { name: "Black Beans" },
    ],
  },
  {
    id: "desserts",
    label: "Desserts",
    items: [
      { name: "Flan" },
      { name: "Churros" },
      { name: "Churros with Dulce de Leche" },
    ],
  },
  {
    id: "kids",
    label: "Kids",
    items: [
      { name: "2 Mini Quesadillas" },
      { name: "Fish Sticks" },
      { name: "Chicken Tenders" },
      { name: "Avocado Bites" },
      { name: "Cauliflower Bites" },
    ],
  },
];

// Separate editable area for limited-time tacos (brief §15). Items added here
// appear on the Food page automatically.
export const LIMITED_TIME_TACOS = {
  id: "limited-time-tacos",
  label: "Limited-Time Tacos",
  items: [],
  note: "Rotating selection — add limited-time tacos here.",
};
